import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useNotifications } from "@/hooks/useNotifications";

export const useCancelReservation = () => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  return useMutation({
    mutationFn: async (reservationId: string) => {
      const { data, error: updateError } = await supabase
        .from('reservations')
        .update({ status: 'cancelled' })
        .eq('id', reservationId)
        .select()
        .single();

      if (updateError) throw updateError;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gym-reservations'] });
      notifications.success('Reserva cancelada exitosamente');
    },
    onError: (error) => {
      console.error('Error cancelling reservation:', error);
      notifications.error('Error al cancelar la reserva');
    },
  });
};